import axios from "axios"


export const glb_url = process.env.REACT_APP_APIS_BACK || "https://localhost:7443"

export const theLab_url = process.env.REACT_APP_THELAB_URL || "https://localhost:3000"


export default {
  /* DEBUT PASSPORTJS */
  getLoginStatus: async () => {
    try {
      const res = await axios.get(glb_url + "/auth/status", {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  postUserLogin: async user => {
    try {
      const res = await axios.post(glb_url + "/auth/login", user, {
        withCredentials: true,
      })
      return {
        err: false,
        data: res.data || "error logging in",
      }
    } catch (err) {
      return {
        err: true,
        data: false,
      }
    }
  },

  registerRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/registerRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkRegisterRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/checkRegisterRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  validCodeRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/validCodeRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  resendCodeRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/resendCodeRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkRegisterCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/checkRegisterCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  validRegisterCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/validRegisterCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  askForNewPasswordEmail : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/askForNewPasswordEmail", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkResetPsswd : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/checkResetPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  setPsswd: async (vals) => {
    try {
      const res = await axios.post(glb_url + "/theScan/setPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  changePassword : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/changePassword", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* FIN PASSPORTJS */

  /* DEBUT SCAN RECRUITER */
  addScanWithPDF: async (vals, onUploadProgress) => {
    try {
      const res = await axios.put(glb_url + "/theScan/addScan", vals, {
        onUploadProgress : onUploadProgress,
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addScanWithDescription : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/addScan", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getScans : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/getScans", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/addCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addMultipleCandidats : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/addMultipleCandidats", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  reInvitCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/reInvitCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  /* FIN SCAN RECRUITER */
}
